module.exports = __webpack_public_path__ + "static/media/[打哈欠]@2x.72038a7e.png";